module.exports = __webpack_public_path__ + "static/saifullahwbg-3158aef4ed37bfcd434c7790ed797a3f.png";